const style = (theme) => {
  const output = {
    root: {
      '& > *': {
        marginTop: 100,
        // paddingBottom: 100,
      },
    },
    wrapper: {
      extend: theme.wrapper,
    },
    text: {
      columnCount: 2,
      columnGap: 80,
      fontSize: 16,
    },
    imageWrapper: {
      position: 'relative',
      zIndex: 1,
      overflow: 'hidden',
      borderRadius: 16,
      width: '100%',
      '&::before': {
        content: '""',
        zIndex: 1,
        display: 'block',
        top: 0,
        left: 0,
        width: '100%',
        paddingBottom: '50%',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    text: {
      columnCount: 1,
      columnGap: 0,
      fontSize: 16,
    },
    imageWrapper: {
      '&::before': {
        paddingBottom: '60%',
      },
    },
  }

  return output
}

export default style
